module.exports = __webpack_public_path__ + "img/twitch.8a163718.svg";